import { render, staticRenderFns } from "./DashboardTopbar.vue?vue&type=template&id=6cf997eb&scoped=true"
import script from "./DashboardTopbar.vue?vue&type=script&lang=js"
export * from "./DashboardTopbar.vue?vue&type=script&lang=js"
import style0 from "./DashboardTopbar.vue?vue&type=style&index=0&id=6cf997eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf997eb",
  null
  
)

export default component.exports